/* Note: This is an autogenerated file. Please DO NOT modify anything manually here. */
import * as Types from "src/generated/graph-api";

import { gql } from "@apollo/client";
export type GQLAccountSettingsTeamMemberContactFieldsFragment = {
	__typename: "IdentityTeamMemberContact";
	id: string;
	role: string | null;
	firstName: string | null;
	lastName: string | null;
	cellPhone: string | null;
	email: string | null;
	companyName: string | null;
	address: {
		__typename: "IdentityAddress";
		street1: string | null;
		street2: string | null;
		city: string | null;
		state: string | null;
		postalCode: string | null;
	} | null;
};

export type GQLAccountSettingsTeamMemberContactFormFieldsFragment = {
	__typename: "IdentityTeamMember";
	id: string;
	contacts: {
		__typename: "IdentityTeamMemberContacts";
		escrowOfficer: {
			__typename: "IdentityTeamMemberContact";
			id: string;
			role: string | null;
			firstName: string | null;
			lastName: string | null;
			cellPhone: string | null;
			email: string | null;
			companyName: string | null;
			address: {
				__typename: "IdentityAddress";
				street1: string | null;
				street2: string | null;
				city: string | null;
				state: string | null;
				postalCode: string | null;
			} | null;
		} | null;
		titleOfficer: {
			__typename: "IdentityTeamMemberContact";
			id: string;
			role: string | null;
			firstName: string | null;
			lastName: string | null;
			cellPhone: string | null;
			email: string | null;
			companyName: string | null;
			address: {
				__typename: "IdentityAddress";
				street1: string | null;
				street2: string | null;
				city: string | null;
				state: string | null;
				postalCode: string | null;
			} | null;
		} | null;
	} | null;
};

export const AccountSettingsTeamMemberContactFieldsFragmentDoc = gql`
    fragment AccountSettingsTeamMemberContactFields on IdentityTeamMemberContact {
  id
  role
  firstName
  lastName
  cellPhone
  email
  companyName
  address {
    street1
    street2
    city
    state
    postalCode
  }
}
    `;
export const AccountSettingsTeamMemberContactFormFieldsFragmentDoc = gql`
    fragment AccountSettingsTeamMemberContactFormFields on IdentityTeamMember {
  id
  contacts {
    escrowOfficer {
      ...AccountSettingsTeamMemberContactFields
    }
    titleOfficer {
      ...AccountSettingsTeamMemberContactFields
    }
  }
}
    ${AccountSettingsTeamMemberContactFieldsFragmentDoc}`;
